import * as React from 'react';
import { Dialog, DialogPanel, DialogBackdrop } from '@headlessui/react'
import DeleteButton from './deleteButton.tsx';
import { clsx } from 'clsx';

type Props = Readonly<{
	isOpen: boolean,
	onClose: Function,
	children?: React.ReactNode
	zIndex?: number,
	classesSize?: string,
	// When false, a click on the backdrop or the Escape key won't close the dialog —
	// only the explicit close button does. Use for a step that shouldn't be
	// dismissed by accident (e.g. SMS verification, where closing strands the user
	// on the now read-only direct debit screen). Defaults to true.
	dismissable?: boolean,
}>;

function DialogStyled({
	isOpen,
	onClose,
	children,
	zIndex = 70,
	classesSize = "min-w-[66vw] max-w-[90vw] min-h-[66vh] max-h-[97vh]",
	dismissable = true
}: Props) {

	return (
		<Dialog open={isOpen} onClose={() => { if (dismissable) onClose(); }} className={clsx("relative", "z-" + zIndex)}>
			<DialogBackdrop className="fixed inset-0 bg-overlay"/>

			<div className="fixed inset-0 flex w-screen items-center justify-center overflow-y-auto">
				<DialogPanel className={clsx("bg-white shadow-lg overflow-auto relative m-6", classesSize)}>
					<DeleteButton onClick={() => onClose()} className="absolute right-2 top-2"/>
					{children}
				</DialogPanel>
			</div>
		</Dialog>
	);
}

export default DialogStyled;

